export default class ArcrFile {
  typeFile!: string
  status!: string
  date_presented!: Date
  file!: string
  comment!: string
}
